// extracted by mini-css-extract-plugin
export var bloc = "citation-module--bloc--593fb";
export var blocChild = "citation-module--blocChild--6fed0";
export var bottomLines = "citation-module--bottomLines--5b878";
export var citation = "citation-module--citation--b6929";
export var h3Text = "citation-module--h3Text--dc269";
export var item = "citation-module--item--7f765";
export var link = "citation-module--link--0a964";
export var mainBloc = "citation-module--mainBloc--32e41";
export var nbLines = "citation-module--nbLines--1c4f6";